export const GET_LIST_ATTRIBUTE = 'GET_LIST_ATTRIBUTE';
export const GET_LIST_CATEGORY = 'GET_LIST_CATEGORY';
export const GET_ALL_PRODUCT = 'GET_ALL_PRODUCT';
export const GET_LIST_CALCULATION_FORMULA = 'GET_LIST_CALCULATION_FORMULA';
export const GET_LIST_COM = 'GET_LIST_COM';
export const GET_PRODUCT_DETAIL = 'GET_PRODUCT_DETAIL';
export const GET_LIST_UNIT = 'GET_LIST_UNIT';





